import { useFormContext } from 'react-hook-form';

export const ToggleButton = ({
  labelTitle,
  registerName,
  value,
  disabled = false
}: {
  labelTitle: string;
  registerName: string;
  value: string;
  disabled: boolean;
}) => {
  const { register } = useFormContext();
  return (
    <div className="flex justify-center items-center h-44">
      <input
        id={value}
        {...register(registerName)}
        type="radio"
        className="peer appearance-none"
        value={value}
        disabled={disabled}
      />
      <label
        htmlFor={value}
        className="border border-solid px-20 py-8 border-[#2E2B36] rounded-22 bg-[#1F1E25] text-[#C9C7D1] peer-checked:border-[#7750E9] peer-checked:text-[#9170F2] peer-checked:border-2"
      >
        {labelTitle}
      </label>
    </div>
  );
};
